import axios from "axios";

export const saveAccountingDates = ({
  token,
  accountingDates,
  startDate,
  data
}) => {
  const requestUrl = `/data/balance/save_accounting_dates`;

  let formData = new FormData();
  // formData.append("access_token", token);
  formData.append("accountingConfig", JSON.stringify(accountingDates));
  formData.append("startDate", startDate);
  formData.append("dataId", data.id);

  return axios.post(requestUrl, formData);
};

export const importBalance = ({
  token,
  sourceModel,
  modelConfig,
  periodConfig,
  multipleModelConfig,
  balanceAttachment,
  data
}) => {
  const requestUrl = `/data/balance/import`;

  var formData = new FormData();

  // formData.append("access_token", token);
  formData.append("sourceModel", sourceModel);
  formData.append("modelConfig", JSON.stringify(modelConfig));
  formData.append("periodConfig", JSON.stringify(periodConfig));
  formData.append("multipleModelConfig", JSON.stringify(multipleModelConfig));
  formData.append("dataId", data.id);

  balanceAttachment.forEach((attachment, i) => {
    formData.append("files[" + i + "]", attachment, attachment.name);
  });

  /*if (balanceAttachment instanceof File) {
    formData.append("file", balanceAttachment, balanceAttachment.name);
  }*/

  return axios.post(requestUrl, formData);
};

export const importAnnexes = (annexes, clientUen) => {
  const requestUrl = `/data/annexes/save`;

  var formData = new FormData();
  formData.append("clientUen", clientUen);

  let annexesData = annexes.map((annexe, i) => {
    formData.append(
      "files[" + i + "]",
      annexe.attachment,
      annexe.attachment.name
    );
    return {
      id: i,
      category: annexe.category.id,
      year: annexe.year,
      certified: annexe.certified ? 1 : 0,
      main: annexe.main ? 1 : 0,
      hidden: annexe.hidden ? 1 : 0
    };
  });
  formData.append("annexes", JSON.stringify(annexesData));

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/balance.js